import { render } from "./level-8.vue?vue&type=template&id=c06d92f4&ts=true"
import script from "./level-8.vue?vue&type=script&lang=ts"
export * from "./level-8.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__